import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationEventReducer} from '../../utils/types';
//actions
import {getEventSponsorCategories, getEvents, getEvent, getEventTodoList, updateEvent, getEventBySlug} from './actions';
//operations
import {
	clearEventDataOperation,
	getEventBySlugOperation,
	getEventOperation,
	getEventSponsorCategoriesOperation,
	getEventTodoListOperation,
	getEventsOperation,
	pendingOperation,
	rejectedOperation,
	updateEventOperation,
} from './operations';

export const initialState: IOrganizationEventReducer = {
	events: null,
	currentEvent: null,
	todoList: [],
	sponsorCategories: null,
	isLoading: false,
};

const organizationEventStore = createSlice({
	name: 'organizationEvent',
	initialState,
	reducers: {
		clearEventData: (state) => clearEventDataOperation(state, initialState),
	},
	extraReducers: (builder) => {
		builder.addCase(getEventSponsorCategories.pending, pendingOperation);
		builder.addCase(getEventSponsorCategories.fulfilled, getEventSponsorCategoriesOperation);
		builder.addCase(getEventSponsorCategories.rejected, rejectedOperation);

		builder.addCase(getEvents.pending, pendingOperation);
		builder.addCase(getEvents.fulfilled, getEventsOperation);
		builder.addCase(getEvents.rejected, rejectedOperation);

		builder.addCase(getEvent.pending, pendingOperation);
		builder.addCase(getEvent.fulfilled, getEventOperation);
		builder.addCase(getEvent.rejected, rejectedOperation);

		builder.addCase(getEventTodoList.pending, pendingOperation);
		builder.addCase(getEventTodoList.fulfilled, getEventTodoListOperation);
		builder.addCase(getEventTodoList.rejected, rejectedOperation);

		builder.addCase(updateEvent.fulfilled, updateEventOperation);

		builder.addCase(getEventBySlug.pending, pendingOperation);
		builder.addCase(getEventBySlug.fulfilled, getEventBySlugOperation);
		builder.addCase(getEventBySlug.rejected, rejectedOperation);
	},
});

export const {clearEventData} = organizationEventStore.actions;

export default organizationEventStore.reducer;
